export const CLEAR_BACK_STATE = {
  __clearBack: true,
};
